
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmiley1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 26,
  width: 48,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M2.12 0q5.86 5.8 11.63 0h1.27q.72.81.79 1.7a1.17 1.15 63.9 0 1-.3.9C11.17 7.37 4.21 7.09 0 2.21V1.09L.85 0h1.27ZM33.85 0q5.81 5.79 11.68 0h1.22q.6.66.79 1.51a1.1 1.1 0 0 1-.23.93c-3.88 4.71-10.8 4.7-14.95.39-.93-.97-.6-1.95.2-2.83h1.29ZM23.8 17q3.84 0 7.06-2.43a1.49 1.49 0 0 1 2.39 1.22c-.09 4.96-4.57 9.56-9.45 9.56-4.88 0-9.36-4.6-9.45-9.56a1.49 1.49 0 0 1 2.39-1.22Q19.96 17 23.8 17Zm-.05 5.29q2.48.02 4.61-2.39a.16.16 0 0 0-.16-.26q-2.24.67-4.44.65-2.19-.02-4.42-.73a.16.16 0 0 0-.17.26q2.09 2.44 4.58 2.47Z"
})));

      const __svgRaw = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\r\n<svg height=\"26\" width=\"48\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0.00 0.00 48.00 26.00\">\r\n<path fill=\"var(--theme-primary, #810ea9)\" d=\"\r\n  M 2.12 0.00\r\n  Q 7.98 5.80 13.75 0.00\r\n  L 15.02 0.00\r\n  Q 15.74 0.81 15.81 1.70\r\n  A 1.17 1.15 63.9 0 1 15.51 2.60\r\n  C 11.17 7.37 4.21 7.09 0.00 2.21\r\n  L 0.00 1.09\r\n  L 0.85 0.00\r\n  L 2.12 0.00\r\n  Z\"\r\n/>\r\n<path fill=\"var(--theme-primary, #810ea9)\" d=\"\r\n  M 33.85 0.00\r\n  Q 39.66 5.79 45.53 0.00\r\n  L 46.75 0.00\r\n  Q 47.35 0.66 47.54 1.51\r\n  A 1.10 1.10 0.0 0 1 47.31 2.44\r\n  C 43.43 7.15 36.51 7.14 32.36 2.83\r\n  C 31.43 1.86 31.76 0.88 32.56 0.00\r\n  L 33.85 0.00\r\n  Z\"\r\n/>\r\n<path fill=\"var(--theme-primary, #810ea9)\" d=\"\r\n  M 23.80 17.00\r\n  Q 27.64 17.00 30.86 14.57\r\n  A 1.49 1.49 0.0 0 1 33.25 15.79\r\n  C 33.16 20.75 28.68 25.35 23.80 25.35\r\n  C 18.92 25.35 14.44 20.75 14.35 15.79\r\n  A 1.49 1.49 0.0 0 1 16.74 14.57\r\n  Q 19.96 17.00 23.80 17.00\r\n  Z\r\n  M 23.75 22.29\r\n  Q 26.23 22.31 28.36 19.90\r\n  A 0.16 0.16 0.0 0 0 28.20 19.64\r\n  Q 25.96 20.31 23.76 20.29\r\n  Q 21.57 20.27 19.34 19.56\r\n  A 0.16 0.16 0.0 0 0 19.17 19.82\r\n  Q 21.26 22.26 23.75 22.29\r\n  Z\"\r\n/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/smiley1.c000ff2daf3a91b202927af8fb5c961a.svg"),
        {
          React: SvgSmiley1,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      